<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()">
    <ng-template>
      @if (!isNew && dataContext?.id) {
        <li>
          <app-excel-list
            [columnDefinition]="itemListColumns"
            [selectedListViewColumns]="itemListSelectedColumns"
            [excelContext]="'PriceListItems'"
            [filter]="excelFilter"
            [fileName]="excelFileName"
          ></app-excel-list>
        </li>
      }
    </ng-template>
  </app-form-header>
  @if (form) {
    <form class="astral-content-width astral-content-width--with-list-surface astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['name']"></astral-input>
          <astral-select [control]="form.controls['listType']" [itemsSource]="listTypes"></astral-select>
          @if (false) {
            <astral-select [control]="form.controls['currencyCode']" [itemsSource]="currencies"></astral-select>
          }
        </astral-layout-group>
      </section>
      @if (!isNew) {
        <section class="astral-section-surface astral-section-surface--list-width astral-stack-m">
          <app-list-view
            [columnDefinition]="itemListColumns"
            [itemsSource]="dataContext.priceListItems"
            [preferencesKey]="'common.pricelist-form.items'"
            (onColumnChange)="onItemListColumnChange($event)"
            (rowClick)="itemClicked($event)"
          ></app-list-view>
          <astral-button variant="primary" type="button" icon="plus" labelKey="CREATE_BTN" (click)="addItem()"></astral-button>
        </section>
      }
    </form>
  }
</section>
